export const phone_lists = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить список <b>{name}<b>?`
    }
  },

  form: {
    title: {
      edit: {
        main: 'Данные списка номеров',
        add_phone: 'Добавить номера',
        added_phones: 'Добавленные номера'
      }
    },

    state: {
      add: 'Добавлен',
      remove: 'Удален'
    },

    field: {
      name: 'Имя',
      phone: 'Номер',
      state: 'Состояние'
    }
  }
};
